module.exports = __webpack_public_path__ + "media/images/vector-20@2x-da6a9e76c7c824ed6e591ed03cad068a.png";